import React, { useState, useCallback, useRef, useEffect } from 'react';
import { connect, useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { convertDateFormat, getformatedDate } from "../../shared/core/datehelper";
import { View, Text, ActivityIndicator, FlatList } from "react-native-web";
import LetterHandler from '../components/LetterHandler';
import { GetDayName, GetAppointmentDate, GetMonthName, ReturnTypeIcon, GetYear, FormateUTCTime } from '../../shared/core/datehelper';
import { fetchLettersFromApi, searchLettersFromApi } from "../../shared/actions/LettersActions";
import getUserId from "../../shared/core/GetToken";
import { fetchProfileFromApi } from '../../shared/actions/ProfileActions';
import { Viewer , Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import { Button, DatePicker, Modal } from "antd";
import getUserInfo from '../../shared/core/GetTokenized';
import { appServices } from '../../shared/redux/actions/appServices';
import Iframe from '../components/Iframe';
const { RangePicker } = DatePicker;
const renderToolbar = (Toolbar) => (
    <>
        <Toolbar />
        <div
            style={{
                borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                marginTop: '4px',
                padding: '4px',
            }}
        >
            Custom element
        </div>
    </>
);
const LettersDocs = props => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin(
        renderToolbar
    );
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
      const PatienInformation = JSON.parse(information);
      const [username, setusername] = useState('');
      const componentRef = useRef();
      const [file, setFile] = React.useState()
      const [htmlLetter, setHtmlLetter] = useState('');
    // const { Profile, isFetching } = props.Profile;
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const [pdfVisible, setPdfVisible] = useState(false);
    const [isLoadingPdf, setIsLoadingPdf] = useState(false);
    const [selectedID, setSelectedID] = useState("");
    const [visible, setVisible] = useState(false);
    const {LetterAndDocumentByIDData , isLetterAndDocumentByIDData}= useSelector((state)=>state.LetterAndDocumentByID)

    // const { Letters, isGettingLetters } = props.Letters
    const { Letters, isGettingLetters } =  useSelector((state)=> state.LetterAndDocument)
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const dispatch= useDispatch()
    const docObj={
        PatientID: Profile && Profile[0].resource.id,
        PageNumber: pageNumber,
        pageSize : pageSize,
    }
    React.useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://indici-pre-production.web.app/assets/js/template.js";
        document.body.appendChild(script)
        // d.div.appendChild(script);
    }, [])

    // React.useEffect(() => {
    //     dispatch(appServices.PatientProfile({
    //         PatientID : Profile[0].resource.id
    //     }))
    //     // props.getProfile();
    // }, [])

    useEffect(() => {
        if(Profile) dispatch(appServices.LetterAndDocument(docObj))
        // props.getLetters(pageSize, pageNumber);
    }, [Profile])

    useEffect(() => {
        if(LetterAndDocumentByIDData){
            if(LetterAndDocumentByIDData[0].entry && LetterAndDocumentByIDData[0].entry[0].resource.extension[2].valueString){
                if ( LetterAndDocumentByIDData[0].entry[0].resource.extension[2].valueString) {
                    setPdfVisible(true)

                    const blob = base64toBlob("data:application/pdf;base64," + LetterAndDocumentByIDData[0].entry[0].resource.extension[2].valueString);
                    if (blob && blob.type === 'application/pdf') {
         const url = URL.createObjectURL(blob);
         setFile(url);
     } else {
         console.error("Invalid blob:", blob);
     }
     
                    setIsLoadingPdf(false);
        
        
                    return;
                }
            }
//             else{ 
//                 if ( LetterAndDocumentByIDData[0].entry &&( LetterAndDocumentByIDData[0].entry[0].resource.content[0].attachment.contentType == "PDF" || LetterAndDocumentByIDData[0].entry[0].resource.content[0].attachment.contentType == "pdf")) {
//                setPdfVisible(true)
//                // console.log('Hello:', LetterAndDocumentByIDData[0].entry[0].resource.resourceType)
//                //alert(LetterAndDocumentByIDData[0].entry[0].resource.resourceType);
//                var b64 = LetterAndDocumentByIDData[0].entry[0].resource.content[0].attachment.data;
//                // var bin = atob(b64);
   
//                // // Embed the PDF into the HTML page and show it to the user
//             //    var obj = document.createElement('object');
//             //    obj.style.width = '100%';
//             //    obj.style.height = '550px';
//             //    obj.type = 'application/pdf';
//             //    obj.data = 'data:application/pdf;base64,' + b64;
//                //document.body.appendChild(obj);
   
//                // `base64String` is the given base 64 data
//                const blob = base64toBlob("data:application/pdf;base64," + LetterAndDocumentByIDData[0].entry[0].resource.content[0].attachment.data.trim());
//             //  console.log("Blob size:", blob.size);
//                if (blob && blob.type === 'application/pdf') {
//     const url = URL.createObjectURL(blob);
//     // console.log("Blob URL created:", url);
//     // window.open(url, '_blank');
//     setFile(url);
// } else {
//     console.error("Invalid blob:", blob);
// }

//             //    setFile(url)
//             //    console.log(url , "url1111111")
//             //    setFile((state) => {
//             //        return state;
//             //    });
//                // document.getElementById("showPDF").appendChild(obj)
//                setIsLoadingPdf(false);
   
   
//                return;
//            } 
           else {
               var decodedHTML = LetterAndDocumentByIDData[0].entry && atob(LetterAndDocumentByIDData[0].entry[0].resource.content[0].attachment.data)
               console.log("NewVaritan" + decodedHTML)
               setVisible(true)
               setHtmlLetter(decodedHTML)
               setHtmlLetter((state) => {
                   return state;
               });
               //document.getElementById("showPDFLetters").innerHTML = decodedHTML
   
               setIsLoadingPdf(false);
           }
        // }
        }
       }, [LetterAndDocumentByIDData])

       const base64toBlob = (data) => {
        try {
            // Cut the prefix `data:application/pdf;base64` from the raw base 64
            const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);
    
            const bytes = atob(base64WithoutPrefix);
            let length = bytes.length;
            let out = new Uint8Array(length);
    
            while (length--) {
                out[length] = bytes.charCodeAt(length);
            }
            // console.log("converting base64 to Blob:", out);
            return new Blob([out], { type: 'application/pdf' });
        } catch (error) {
            console.error("Error converting base64 to Blob:", error);
            return null; // Return null in case of an error
        }
    };

    function handlePrint() {


        var bodyHtml = /<body.*?>([\s\S]*)<\/body>/.exec(htmlLetter)[1];
        console.log("hello test " + bodyHtml)
        //alert(bodyHtml);

        var a = window?.open();
        a.document.write('<html>');

        a.document.write('<head>');
        a.document.write('<link href="https://devnhl.indici.ie/Content/style.css" rel="stylesheet"> <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" rel="stylesheet" type="text/css">  <link href="https://devnhl.indici.ie/Content/CustomCss/MailMerge/MailMergePrint.css" rel="stylesheet"> <script src="https://devnhl.indici.ie/Scripts/jquery-2.1.4.min.js"></script>');
        a.document.write('<style>.watermark{height:100%;display:block;position:relative}.watermark::after{content:"";background:url(https://banner2.cleanpng.com/20180512/oxe/kisspng-paper-rubber-stamp-stock-photography-royalty-free-5af72d03738f71.0212011215261483554733.jpg) no-repeat;opacity:0.2;top:0;left:0;bottom:0;right:0;position:absolute;z-index:-1} @media print{*{-webkit-print-color-adjust:exact}} *{-webkit-print-color-adjust: exact !important; color-adjust: exact !important;}@media screen{div.divFooter{display: none;}}@media print{div.divFooter{position: fixed; bottom: 0;}}</style>')
        a.document.write('</head>');

        a.document.write('<body>');

        a.document.write('<div className="watermark"><div className="col-md-12">' + bodyHtml + '</div>')
        a.document.write('<div className="divFooter"><p id="hello"></p></div></div>');
        a.document.write('<div className="divFooter">' + username + '</div></div>');


        //a.document.write(htmlLetter);


        a.document.write('<script>var currentdate=new Date();var datetime="Printed: " + currentdate.getDate() + "/" + (currentdate.getMonth()+1) + "/" + currentdate.getFullYear() + " @ " + currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();document.getElementById("hello").innerHTML=datetime;</script>')
        a.document.write('</body></html>');




        a.document.close();


        setTimeout(function () { a.print(); }, 500);
        a.onfocus = function () { setTimeout(function () { a.close(); }, 500); }
    }
    const dateFormat = 'DD-MM-YYYY';
    const dateChange = (date, dateString) => {
        if (date === null) {
            dispatch(appServices.LetterAndDocument(docObj))
            // props.getLetters(pageSize, pageNumber);
        }
        else {
            console.log(dateString , "date ")
            // console.log(dateString.toString() , "date 0")
            // var str = dateString.toString();
            // str = str.split(",");
            // console.log(str , "date 1")
            // props.searchLetters(JSON.stringify(date[0]).replace(/['"]+/g, ''), JSON.stringify(date[1]).replace(/['"]+/g, ''))
            // alert(getformatedDate(str[0]) + " 00:00:00" + ",," + getformatedDate(str[1]) + " 23:59:59")
            //
            const date1= convertDateFormat(dateString[0])
            const date2= convertDateFormat(dateString[1])
            const searcObj={
                PatientID: Profile[0].resource.id ,
                StartDate : getformatedDate(date1) + " 00:00:00",
                EndDate:    getformatedDate(date2) + " 23:59:59" ,
                PageNumber: pageNumber ,
                pageSize: pageSize
            }
            dispatch(appServices.LetterAndDocument(searcObj))
            // props.searchLetters(getformatedDate(str[0]) + " 00:00:00", getformatedDate(str[1]) + " 23:59:59")

        }

    }
    return (
        <div>
            {/* <Header />
            <div id="myphonemenu" className="page-body">
                <Sidebar /> */}
                <div className="page-content-wrapper">
                    <div className="page-content-wrapper-inner">
                        <div className="viewport-header">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb has-arrow">
                                    <li className="breadcrumb-item">
                                        <a href="#">Dashboard</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Letter & Documents</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="content-viewport">
                          
                            <div className="row">
                                <div className="col-12">
                                    <div className="grid">
                                        <div className="grid-body">
                                            <h2 className="grid-title">Letter & Documents</h2>
                                            <div className="item-wrapper">
                                                {/* <div className="row mb-2">
                                                    <div className="col-md-8 mx-auto">
                                                        <div className="alert alert-warning" role="alert">
                                                            <h6 className="alert-heading">Please Note:</h6> */}

                                                {
                                                     Profile  && Profile.length ? (
                                                        // <p>{Profile[0].resource.extension[9].hasOwnProperty('valueString') ? Profile[0].resource.extension[9].valueString :"N/A" }</p>
                                                        Profile[0].resource.extension.map((item, index) => {
                                                            return (
                                                                item.url == "LetterDisclaimer" &&
                                                                <div className="row mb-2">

                                                                    <div className="col-md-8 mx-auto">
                                                                        <div className="alert alert-warning" role="alert">
                                                                            <h6 className="alert-heading">Please Note:</h6>

                                                                            <p>{item.valueString ? item.valueString : "N/A"}</p>
                                                                            {isFetching && <ActivityIndicator color='blue' size='small' />}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            )
                                                        })
                                                    ) : null

                                                }
                                                {/* {Profile.map((person, i) => {
                                                                    <p>{person.resource.extension[8] !== undefined
                                                                        ? person.resource.extension[8].valueString
                                                                        : 'NO Data Found'}</p>
                                                                })} */}
                                                {/* <p>   {!isFetching && typeof (Profile[0].resource.extension[8].valueString) !== 'undefined' ? Profile[0].resource.extension[8].valueString : null}</p> */}
                                                {/* <p>{state.immuneMg}</p> */}
                                                {/* <p>Please be aware that the vaccination information displayed on this screen relates only to vaccines that were scheduled and/or administered by your treatment centre. Any vaccines administered outside of your treatment centre will not be recorded here</p> */}
                                                {/* </div>
                                                    </div>
                                                </div> */}

                                                <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 10, paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }}>
                                                    <Text>Select Date to Search </Text>
                                                    <RangePicker format={dateFormat} onChange={dateChange} />
                                                </View>
                                                <div className="drive-wrapper drive-grid-view">
                                                    <div className="grid-items-wrapper">
                                                        {
                                                            isGettingLetters && <View style={{ textAlign: 'center', marginBottom: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
                                                        }
                                                        {
                                                            Letters && Letters.length ? (
                                                                Letters.map((item) => {
                                                                    return (
                                                                        <LetterHandler
                                                                            letterDate={GetAppointmentDate(item.resource.extension[1].valueDateTime) + ' ' + GetMonthName(item.resource.extension[1].valueDateTime) + ' ' + GetYear(item.resource.extension[1].valueDateTime)}
                                                                            letterDetail={item.resource.type.coding[0].display}
                                                                            letterId={item.resource.id}
                                                                            selectedID={selectedID}
                                                                            setSelectedID={setSelectedID}
                                                                        />
                                                                    )
                                                                })
                                                            ) : !isGettingLetters && <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                                                                <Text style={{ marginTop: 10, }}>No Records Found</Text>
                                                            </View>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            {/* </div> */}
            <Modal
                title="Letter Details"
                centered
                open={visible}
                onOk={() =>{
                    dispatch(appServices.gettingLetterAndDocumentByIDClear())
                     setVisible(false)}}
                onCancel={() =>{ 
                    dispatch(appServices.gettingLetterAndDocumentByIDClear())
                    setVisible(false)}}
                // afterClose={() => document.getElementById("showPDFLetters").innerHTML = ""}
                style={{ top: 10, bottom: 90, }}
                width={1000}
                footer={[
                    <Button key="back" onClick={() => {
                        dispatch(appServices.gettingLetterAndDocumentByIDClear())
                        setVisible(false)}}>
                        Close
                    </Button>,
                    <Button key="submit" type="primary" onClick={() => handlePrint()}>
                        Print
                    </Button>
                ]}
            >
                <div style={{ height: '100%', width: '100%' }}>
                    <div ref={componentRef} style={{ padding: 2, }} className="PDF" id="showPDFLetters">
                        {/* <OuterHtml commingHtml={htmlLetter} /> */}
                        <div className="watermark">
                            <Iframe printRef={componentRef} content={htmlLetter} />
                        </div>

                    </div>
                </div>

            </Modal>


            <Modal
                title="PDF File"
                centered
                open={pdfVisible}
                onOk={() =>{
                    dispatch(appServices.gettingLetterAndDocumentByIDClear())
                     setPdfVisible(false)}}
                onCancel={() =>{
                    dispatch(appServices.gettingLetterAndDocumentByIDClear())
                     setPdfVisible(false)}}
                afterClose={() => document.getElementById("showPDF").innerHTML = ""}
                style={{ top: 10, bottom: 90, overflow: "hidden" }}
                width={1000}
            >
                <div
                    style={{
                        border: '1px solid rgba(0, 0, 0, 0.3)',
                        height: '750px',
                    }}
                >
                    <Viewer fileUrl={file} plugins={[
                        defaultLayoutPluginInstance,
                    ]} />
                </div>
                <div className="PDF" id="showPDF">
                </div>
                <p id="hee">
                    {isLoadingPdf && <View style={{ justifyContent: 'center', alignItems: 'center' }}><ActivityIndicator size="small" color="#00A1DE" /><Text>Loading. Please wait...</Text></View>}
                </p>
            </Modal>
        </div>
    )
}


// function mapStateToProps(state) {
//     return {
//         Letters: state.Letters,
//         Profile: state.Profile,
//     }
// }

// function mapDispatchToProps(disptach) {
//     return {
//         // getProfile: () => disptach(fetchProfileFromApi()),
//         // getLetters: (pageSize, pageNumber) => disptach(fetchLettersFromApi(pageSize, pageNumber)),
//         // searchLetters: (fromDate, toDate) => disptach(searchLettersFromApi(fromDate, toDate)),
//     }
// }
// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(LettersDocs)
export default LettersDocs




